import { t } from '@lingui/core/macro';
import { Box, Typography } from '@pocketlaw/tetris';
export function ContactValue(props) {
    const { value, title } = props;
    const noValue = t({
        message: 'Not provided',
        comment: 'Contact library - No provided value',
    });
    return (<Box flexDirection="column">
      <Typography $truncate $color="semantic.text.100" $fontSize="tiny" $lineHeight="neutralized" $fontWeight="medium">
        {title}
      </Typography>

      <Typography $truncate $color={value ? 'semantic.text.300' : 'semantic.text.100'} $fontSize="small" $lineHeight="neutralized">
        {value || noValue}
      </Typography>
    </Box>);
}
